import React, { useMemo, useCallback } from "react";
import { useSelector } from "react-redux";

import RightDrawerModal from "../../RightDrawerModal";
import {
  SUMMARY_$,
  MOVE_STOP,
  TRANSFER_STOP,
  MAKE_MORE_CHANGES,
  SAVE,
  TRANSFER,
  MOVE,
  SUCCESSFUL_TRANSFER_MESSAGE_$,
  TRANSFERRED,
  MOVED,
} from "../../../constants/strings";
import palette from "../../styles/palette";

import { useOverlay } from "../../Overlay";
import TransferActionButtons from "../TransferTo/components/TransferActionButtons";
import { formatMessage } from "../../../utils/string";
import SummaryCard from "./components/SummaryCard";
import { getTransferRouteCode } from "../../../store/selectors/route";

const TransferSummary = ({ open, onClose, isTransfer, onSaveClick }) => {
  const { showOverlayWhile } = useOverlay();
  const routeCode = useSelector(getTransferRouteCode);

  const onMoreChangesClick = useCallback(() => {
    onClose();
  }, [onClose]);

  const handleSaveClick = useCallback(async () => {
    const success = await onSaveClick();
    if (success) {
      onClose();
    }
  }, [onClose, onSaveClick]);

  const buttonsConfig = useMemo(
    () => ({
      moreChanges: {
        isDisabled: false,
        color: {
          bg: palette.yellow,
          border: palette.goldenGrass,
          text: palette.typography.black.solid,
        },
        title: MAKE_MORE_CHANGES,
        onClick: onMoreChangesClick,
      },
      save: {
        isDisabled: false,
        color: {
          bg: palette.pictonBlue,
          border: palette.endeavour,
        },
        title: SAVE,
        onClick: showOverlayWhile(handleSaveClick),
      },
    }),
    [onMoreChangesClick, handleSaveClick, showOverlayWhile]
  );

  return (
    <RightDrawerModal
      open={open}
      onClose={onClose}
      title={isTransfer ? TRANSFER_STOP : MOVE_STOP}
      actions={<TransferActionButtons config={buttonsConfig} />}
    >
      <SummaryCard
        routeCode={routeCode}
        title={formatMessage(SUMMARY_$, isTransfer ? TRANSFER : MOVE)}
        successMessage={formatMessage(
          SUCCESSFUL_TRANSFER_MESSAGE_$,
          isTransfer ? TRANSFERRED : MOVED
        )}
      />
    </RightDrawerModal>
  );
};

export default React.memo(TransferSummary);
